

import React from 'react'

const cart = () => {
  return (
    <div>cart</div>
  )
}

export default cart